import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer.js'
import Slider from "react-slick"
import ProductTabs from '../../components/ProductTabs'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';

const ActivatedCarbonPage = () => {

    const productData = {
        description: [
            "Activated Carbon is a highly porous form of carbon with an extensive internal surface area, making it an exceptional adsorbent for removing impurities, contaminants, and unwanted substances from gases and liquids.",
            "Available in various forms including granular (GAC), powdered (PAC), and pelletized activated carbon to suit different industrial applications.",
            "• Bags: typically 25 kg polypropylene bags with inner polyethylene liner for moisture protection — ideal for small to medium orders.",
            "• Jumbo bags (FIBC): 500 kg to 1000 kg big bags for bulk handling and storage efficiency.",
            "• Drums: steel or fiber drums for specialized grades requiring extra protection from moisture and contamination.",
            "• Bulk delivery: available in bulk tankers or containers for large-scale industrial operations.",
            "• Packing & labeling: all packages supplied with technical data sheets, safety information, and proper handling instructions. Moisture-resistant packaging ensures product quality during storage and transport."
        ],
        applications: [
            {
                id: 1,
                title: "Water Treatment & Purification",
                description: "Activated Carbon is extensively used in municipal and industrial water treatment to remove organic compounds, chlorine, taste, odor, and color from drinking water and wastewater.",
                image: "/images/products/activated-carbon/water.jpg"
            },
            {
                id: 2,
                title: "Air Purification & Gas Treatment",
                description: "Used in air filtration systems to remove volatile organic compounds (VOCs), odors, and harmful gases from industrial emissions and indoor air quality control systems.",
                image: "/images/products/activated-carbon/air.jpg"
            },
            {
                id: 3,
                title: "Food & Beverage Processing",
                description: "Activated Carbon is used for decolorization, purification, and removal of impurities in sugar refining, edible oil processing, beverage production, and food-grade applications.",
                image: "/images/products/activated-carbon/food.jpg"
            },
            {
                id: 4,
                title: "Pharmaceutical & Chemical Industries",
                description: "Essential for purification processes, solvent recovery, catalyst support, and removal of impurities in pharmaceutical manufacturing and chemical processing operations.",
                image: "/images/products/activated-carbon/pharma.jpg"
            }
        ]
    };

    return (
        <Fragment>
            <SEO title={seoData.activatedCarbon.title} description={seoData.activatedCarbon.description} keywords={seoData.activatedCarbon.keywords} />
            <Navbar/>
            <PageTitle pageTitle="Activated Carbon" pagesub="Activated Carbon" parentPage="Products" parentLink="#" />
            <div className="team-pg-area product-page-section">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <Slider dots={true} arrows={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                                        <div className="image-box">
                                            <img src='/images/products/activated-carbon/ac1.jpg' alt="Activated Carbon" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/activated-carbon/ac2.jpg' alt="Activated Carbon Granules" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/activated-carbon/ac3.jpg' alt="Activated Carbon Packaging" />
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>Activated Carbon</h2>
                                    <ul>
                                        <li>Material: <span>Coconut Shell / Coal Based</span></li>
                                        <li>Form: <span>Granular (GAC) / Powder (PAC)</span></li>
                                        <li>Iodine Number: <span>900-1200 mg/g</span></li>
                                        <li>Packaging: <span>25kg Bags, 500kg Jumbo Bags</span></li>
                                        <li>Surface Area: <span>800-1500 m²/g</span></li>
                                        <li>Moisture Content: <span>Max 5%</span></li>
                                        <li>Ash Content: <span>Max 8%</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProductTabs product={productData} />
                </div>
            </div>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default ActivatedCarbonPage;
